/**
 * Shared site footer.
 *
 * Two ways to populate the links, both rendered with identical
 * typography/spacing (text-xs, gray-500, `|` separators):
 *
 *   - Default: Privacy Policy | Terms of Service, plus any `extraLinks`.
 *   - `links` override: pass a full ordered list of { label, href } to
 *     replace the default pair entirely (e.g. the conveyancer portal's
 *     Code of Conduct | Terms of Service | POPIA & Privacy Policy).
 *
 * In both cases the separator + copyright tail are identical, so the
 * footer looks the same on every page regardless of which app renders it.
 */
export function Footer({ extraLinks = [], links = null } = {}) {
  const items = links || [
    { label: "Privacy Policy", href: "/privacy" },
    { label: "Terms of Service", href: "/terms" },
    ...extraLinks,
  ];

  return (
    <footer className="border-t bg-white px-4 py-4 text-center text-xs text-gray-500 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-400">
      {items.map((link, idx) => (
        <span key={link.href}>
          {idx > 0 && <span className="mx-2">|</span>}
          <a href={link.href} className="hover:underline">
            {link.label}
          </a>
        </span>
      ))}
      <span className="mx-2">|</span>
      <span>&copy; {new Date().getFullYear()} BidConvey (Pty) Ltd</span>
    </footer>
  );
}
